
<template>
  <div class="footer">
    <div class="top-shadow"></div>
    <div class="footer-grid">
      <div class="footer-section">
        <div class="center">
          <h4>Autumn 2022 Fellowship</h4>
          <p><i>To everyone involved, thank you.</i></p>
        </div>
        <div class="line-divider"></div>
        <div class="sub-section">
          <p>
            <b><i>Fellows</i></b
            ><br />
            <a href="https://www.carsongracelevine.com/" target="_blank"
              >Carson Levine</a
            ><br />
            <a href="https://jerameyhampton.com/" target="_blank"
              >Jeramey Hampton</a
            ><br />
            Rachel Lau<br />
          </p>
        </div>
        <div class="sub-section images">
          <p>
            <b><i>Patrons</i></b>
          </p>
          <div class="logos">
            <a href="https://otherinter.net" target="_blank">
              <img src="figures/oi-logo.png"
            /></a>
            <a href="https://www.index-space.org/" target="_blank"
              ><img
                style="mix-blend-mode: multiply"
                src="figures/index-logo.png"
            /></a>
          </div>
        </div>
        <div class="sub-section">
          <p>
            <b><i>Spaces</i></b
            ><br />
            <a href="https://daze.nyc/" target="_blank">Daze</a>, Willem
            Simons<br />
            <a href="https://twitter.com/hiredbyeternal" target="_blank"
              >Eternal</a
            >, Reggie James<br />
            <a
              href="https://www.are.na/teal/visiting-the-factory-afevgwt5ugs"
              target="_blank"
              >The Factory</a
            >, Yatú Espinosa<br />
            <a href="https://thegarage.dev/" target="_blank">Garage</a>, Cyril
            Engmann<br />
            <a
              href="https://d1on0x8owq06rr.cloudfront.net/9d45bf09aecc87055042a7bea4bff567-Quay%20Sunset.jpg"
              target="_blank"
              >Quay</a
            >, Sam Panter<br />
            <a
              href="https://www.are.na/teal/visiting-the-playground"
              target="_blank"
              >The Playground</a
            >, Norm O'Hagan<br />
            <a href="https://www.instagram.com/processa.art/" target="_blank"
              >Processa</a
            >, Kam Robinson<br />
          </p>
        </div>
        <div class="sub-section">
          <p>
            <b><i>Organizers</i></b
            ><br />
            Aaron Z. Lewis, Yatú Espinosa, Kara Kittel, Norm O’Hagan, Sean
            Thielen-Esparza
          </p>
        </div>
      </div>
      <!-- <div class="footer-section">
        <h4>To Contact, Patron, or Partner</h4>
        <p>Email ...</p>
        <p>
          <i>or <a href="/subscribe">Subscribe for Updates!</a></i>
        </p>
      </div> -->
      <div class="footer-section links">
        <h4>A research artifact by</h4>
        <br />
        <br />
        <div class="links-org">
          <p>
            <a href="https://lrft.institute" target="_blank">
              <img src="figures/lrft-logo.png" class="smaller" />
              <b>Leave Room for Thoughts</b>
            </a>
          </p>
          <p class="subtitle">
            An institution to encourage creative exploration, by
            <a href="https://tealprocess.net" target="_blank"
              >Teal Process & Company</a
            >.
          </p>
        </div>
        <div class="links-org">
          <p>
            <a href="https://otherinter.net" target="_blank">
              <img src="figures/oi-logo.png" />
              <b>Other Internet</b>
            </a>
          </p>
          <p class="subtitle">
            An applied research organization exploring pro-social applications
            of new media technologies.
          </p>
        </div>
      </div>
      <div class="campus-follow">
        <a
          href="https://www.are.na/leave-room-for-thoughts/campus-complex"
          target="_blank"
          rel="noopener"
          ><svg
            width="41"
            height="24"
            viewBox="0 0 41 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M40.1099 16.8177L34.4955 12.3989C34.1518 12.1292 34.1518 11.6863 34.4955 11.4158L40.1102 6.99804C40.4549 6.7278 40.599 6.27119 40.4307 5.98395C40.2621 5.69753 39.7913 5.59558 39.3857 5.7574L32.7094 8.42047C32.3035 8.58391 31.9211 8.36114 31.8602 7.92691L30.8562 0.789158C30.7942 0.355202 30.4684 0 30.1309 0C29.7951 0 29.4695 0.355202 29.4091 0.788888L28.4046 7.92718C28.3432 8.36141 27.9613 8.58364 27.5549 8.42074L20.9889 5.8019C20.5817 5.63954 19.9184 5.63954 19.5122 5.8019L12.9452 8.42074C12.5391 8.58364 12.1566 8.36141 12.0958 7.92718L11.0926 0.788888C11.0306 0.355202 10.7053 0 10.3692 0C10.032 0 9.70585 0.355202 9.64526 0.788888L8.6407 7.92718C8.57983 8.36141 8.19767 8.58364 7.79154 8.42074L1.11543 5.75821C0.709564 5.59558 0.239604 5.69806 0.0710115 5.98422C-0.097312 6.27173 0.0462343 6.72861 0.389884 6.99831L6.00516 11.4161C6.34908 11.6866 6.34908 12.1295 6.00516 12.3994L0.389884 16.8177C0.045157 17.088 -0.0975814 17.5718 0.0704729 17.8923C0.239335 18.2132 0.709294 18.3421 1.11462 18.1792L7.73095 15.5183C8.13762 15.3557 8.51574 15.5771 8.57256 16.0113L9.52703 23.2114C9.58466 23.6448 9.96278 23.9997 10.3673 23.9997C10.7713 23.9997 11.1497 23.6451 11.2076 23.2114L12.1636 16.0113C12.2202 15.5771 12.5999 15.3559 13.0045 15.5183L19.5122 18.1339C19.9178 18.2973 20.5814 18.2973 20.9873 18.1339L27.494 15.5183C27.8991 15.3557 28.2777 15.5771 28.3356 16.0113L29.2917 23.2114C29.3488 23.6448 29.7272 23.9997 30.1306 23.9997C30.5352 23.9997 30.9135 23.6451 30.9709 23.2114L31.927 16.0113C31.9852 15.5771 32.3633 15.3559 32.7683 15.5183L39.3855 18.1792C39.7895 18.3421 40.2608 18.2129 40.4293 17.8925C40.5982 17.5727 40.4547 17.0888 40.1102 16.8186L40.1099 16.8177ZM25.8253 12.455L20.8807 16.2673C20.5346 16.5343 19.9669 16.5343 19.6219 16.2673L14.6756 12.455C14.3298 12.188 14.3271 11.7484 14.6702 11.4773L19.6256 7.56847C19.9687 7.29742 20.5313 7.29742 20.8747 7.56847L25.8302 11.4773C26.1741 11.7481 26.1714 12.1877 25.8248 12.4553L25.8253 12.455Z"
              fill="#2C81A3"
            ></path>
          </svg>
        </a>
        <a
          href="https://twitter.com/campuscomplex"
          target="_blank"
          rel="noopener"
          ><svg
            width="25"
            height="20"
            viewBox="0 0 25 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.9799 5.02848C21.9944 5.24123 21.9944 5.45397 21.9944 5.66868C21.9944 12.2108 17.0783 19.7559 8.08895 19.7559V19.752C5.43346 19.7559 2.83314 18.9853 0.597656 17.5324C0.983785 17.5795 1.37185 17.603 1.76088 17.604C3.96153 17.6059 6.09927 16.8579 7.83056 15.4804C5.73927 15.4402 3.9054 14.0589 3.26475 12.0422C3.99733 12.1853 4.75217 12.1559 5.4712 11.9569C3.1912 11.4902 1.55088 9.46083 1.55088 7.10397V7.04123C2.23024 7.42456 2.99088 7.6373 3.76895 7.66083C1.62153 6.20691 0.959592 3.31279 2.25637 1.05005C4.73766 4.14319 8.39862 6.02358 12.3286 6.2226C11.9348 4.50299 12.4728 2.70103 13.7425 1.49221C15.7109 -0.382304 18.8067 -0.286225 20.657 1.70691C21.7515 1.48828 22.8006 1.08142 23.7606 0.504951C23.3957 1.65103 22.6322 2.62456 21.6122 3.24319C22.5809 3.1275 23.5273 2.86475 24.4186 2.46377C23.7625 3.45985 22.936 4.3275 21.9799 5.02848Z"
              fill="#2C81A3"
            ></path>
          </svg>
        </a>
        <a
          href="https://www.instagram.com/campus.complex/"
          target="_blank"
          rel="noopener"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00313 1.08748C3.24375 1.38279 2.60156 1.77654 1.95937 2.41873C1.31719 3.05623 0.923438 3.7031 0.628125 4.45779C0.342188 5.18904 0.15 6.0281 0.09375 7.25623C0.0375 8.48435 0.0234375 8.8781 0.0234375 12.0094C0.0234375 15.1406 0.0375 15.5344 0.09375 16.7625C0.15 17.9906 0.346875 18.8297 0.628125 19.5609C0.923438 20.3203 1.31719 20.9625 1.95937 21.6047C2.60156 22.2469 3.24375 22.6406 4.00313 22.9359C4.73438 23.2219 5.57344 23.414 6.80156 23.4703C8.02969 23.5265 8.42344 23.5406 11.5547 23.5406C14.6859 23.5406 15.0797 23.5265 16.3078 23.4703C17.5359 23.414 18.375 23.2172 19.1062 22.9359C19.8656 22.6406 20.5078 22.2469 21.15 21.6047C21.7922 20.9625 22.1859 20.3203 22.4812 19.5609C22.7672 18.8297 22.9594 17.9906 23.0156 16.7625C23.0719 15.5344 23.0859 15.1406 23.0859 12.0094C23.0859 8.8781 23.0719 8.48435 23.0156 7.25623C22.9594 6.0281 22.7625 5.18904 22.4812 4.45779C22.1859 3.7031 21.7922 3.05623 21.1547 2.41873C20.5125 1.77654 19.8703 1.38279 19.1109 1.08748C18.3797 0.801538 17.5406 0.609351 16.3125 0.553101C15.0844 0.496851 14.6906 0.482788 11.5594 0.482788C8.42812 0.482788 8.03438 0.496851 6.80625 0.553101C5.57344 0.604663 4.73438 0.801538 4.00313 1.08748ZM16.2141 2.62498C17.3391 2.67654 17.9484 2.86404 18.3562 3.02341C18.8953 3.23435 19.2797 3.48279 19.6828 3.88591C20.0859 4.28904 20.3344 4.67341 20.5453 5.21248C20.7047 5.62029 20.8922 6.22966 20.9437 7.35466C21 8.56873 21.0094 8.93435 21.0094 12.014C21.0094 15.0937 20.9953 15.4594 20.9437 16.6734C20.8922 17.7984 20.7047 18.4078 20.5453 18.8156C20.3344 19.3547 20.0859 19.739 19.6828 20.1422C19.2797 20.5453 18.8953 20.7937 18.3562 21.0047C17.9484 21.164 17.3391 21.3515 16.2141 21.4031C15 21.4594 14.6344 21.4687 11.5547 21.4687C8.475 21.4687 8.10938 21.4547 6.89531 21.4031C5.77031 21.3515 5.16094 21.164 4.75313 21.0047C4.21406 20.7937 3.82969 20.5453 3.42656 20.1422C3.02344 19.739 2.775 19.3547 2.56406 18.8156C2.40469 18.4078 2.21719 17.7984 2.16563 16.6734C2.10938 15.4594 2.1 15.0937 2.1 12.014C2.1 8.93435 2.11406 8.56873 2.16563 7.35466C2.21719 6.22966 2.40469 5.62029 2.56406 5.21248C2.775 4.67341 3.02344 4.28904 3.42656 3.88591C3.82969 3.48279 4.21406 3.23435 4.75313 3.02341C5.16094 2.86404 5.77031 2.67654 6.89531 2.62498C8.10938 2.56873 8.475 2.55935 11.5547 2.55935C14.6344 2.55935 15 2.56873 16.2141 2.62498Z"
              fill="#2C81A3"
            ></path>
            <path
              d="M5.63281 12.0141C5.63281 15.2859 8.28594 17.9344 11.5531 17.9344C14.8203 17.9344 17.4734 15.2812 17.4734 12.0141C17.4734 8.74687 14.825 6.09375 11.5531 6.09375C8.28125 6.09375 5.63281 8.74219 5.63281 12.0141ZM15.3969 12.0141C15.3969 14.1375 13.6766 15.8578 11.5531 15.8578C9.42969 15.8578 7.70938 14.1375 7.70938 12.0141C7.70938 9.89062 9.42969 8.17031 11.5531 8.17031C13.6766 8.17031 15.3969 9.89062 15.3969 12.0141Z"
              fill="#2C81A3"
            ></path>
            <path
              d="M17.7148 7.24219C18.4785 7.24219 19.0977 6.62308 19.0977 5.85938C19.0977 5.09567 18.4785 4.47656 17.7148 4.47656C16.9511 4.47656 16.332 5.09567 16.332 5.85938C16.332 6.62308 16.9511 7.24219 17.7148 7.24219Z"
              fill="#2C81A3"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  props: [],
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style>
.footer {
  width: 100%;
  position: relative;
  background: var(--tan-02);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16rem;
}

.footer .top-shadow {
  position: absolute;
  top: 0;
  height: 40px;
  width: 100%;
  background: var(--tan-01);
  box-shadow: 0px 21px 30px -5.61px rgba(114, 74, 13, 0.2);
}

.footer .footer-grid {
  padding: 4rem;
  box-sizing: border-box;
  width: 100%;
  min-height: 80px;
  width: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 4rem;
  max-width: calc(100% - 40px);
  margin-top: 14rem;
}

.footer .footer-grid .footer-section {
  border: 1.5px solid #e0c79f;
  padding: 3rem;
  padding-bottom: 0.5rem;
  width: 100%;
  border-radius: 1rem;
}

.footer .footer-grid .footer-section:nth-child(3) {
  border-top-right-radius: 8rem;
}

.footer .footer-grid .footer-section:nth-child(2) {
  border-top-left-radius: 1rem;
  border-bottom-right-radius: 4rem;
}

.footer .footer-grid .footer-section:nth-child(1) {
  border-top-left-radius: 1rem;
  border-top-right-radius: 7rem;
}

.footer .footer-grid .footer-section h4 {
  margin: 0;
}

.footer .footer-grid .footer-section.links p a {
  line-height: 120%;
  text-decoration: none;
  opacity: 0.8;
}

.footer .footer-grid .footer-section.links .links-org {
  font-family: "Scala";
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 150%;
  margin-bottom: 2rem;
}

.footer .footer-grid .footer-section.links .links-org p {
  margin-top: 0;
  margin-bottom: 0;
}

.footer .footer-grid .footer-section.links .links-org img {
  height: 3rem;
  margin-bottom: -1rem;
  margin-right: 1rem;
}

.footer .footer-grid .footer-section.links .links-org img.smaller {
  height: 2.6rem;
  margin-right: 1.4rem;
}

.footer .footer-grid .footer-section.links .links-org p.subtitle {
  padding-left: 4rem;
  margin-bottom: 1rem;
}

.footer .footer-grid .footer-section.links .links-org p b {
  font-style: italic;
}

.footer .footer-grid .footer-section.links .links-org a b {
  display: inline-block;
  text-decoration: underline;
  transition: transform
    var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.footer .footer-grid .footer-section.links .links-org a {
  text-decoration: underline;
  opacity: 1;
}

.footer .footer-grid .footer-section.links .links-org a:hover {
  opacity: 1;
  text-decoration: none;
}

.footer .footer-grid .footer-section.links .links-org a:hover b {
  transform: translateX(3px);
  text-decoration: none;
}

.footer .footer-grid .footer-section .sub-section.images p {
  margin-bottom: 0.5rem;
}

.footer .footer-grid .footer-section .sub-section.images .logos {
  display: flex;
  flex-direction: row;
  grid-gap: 1.5rem;
}

.footer .footer-grid .footer-section .sub-section.links p a b i {
  text-decoration: underline;
  opacity: 1;
}

.footer .footer-grid .footer-section .sub-section.images img {
  height: 24px;
  width: auto;
}

.footer .footer-grid .footer-section .sub-section.images img:nth-child(1) {
  height: 32px;
}

.line-divider {
  height: 1.5px;
  width: 100%;
  background: #e0c79f;
  border-radius: 4px;
}

.center {
  text-align: center;
}

.campus-follow {
  display: flex;
  grid-gap: 2rem;
  align-items: center;
}

.campus-follow a svg {
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.campus-follow a svg path {
  fill: var(--blue-02);
}

.campus-follow a:hover svg path {
  fill: var(--orange-02);
}
.campus-follow a:active {
  transform: scale(0.8);
}
</style>
